import { render, staticRenderFns } from "./CreateSystemUser.vue?vue&type=template&id=33616e54&"
import script from "./CreateSystemUser.vue?vue&type=script&lang=ts&"
export * from "./CreateSystemUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports